import { render, staticRenderFns } from "./marketing-loading.vue?vue&type=template&id=b4fd1362"
import script from "./marketing-loading.vue?vue&type=script&lang=js"
export * from "./marketing-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports